(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Qsched_directionDetailController', Qsched_directionDetailController);

    Qsched_directionDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Qsched_direction'];

    function Qsched_directionDetailController($scope, $rootScope, $stateParams, previousState, entity, Qsched_direction) {
        var vm = this;

        vm.qsched_direction = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:qsched_directionUpdate', function(event, result) {
            vm.qsched_direction = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
